export enum ContactUsValidation {
    ResSpecialChar = 0,
    ResSpecialCharNum = 1,
    ResSpecialCharExceptHyphen = 2,
    PasteSpecialChar = 3,
    PasteSpecialCharExceptHyphen = 4,
    PasteSpecialCharNum = 5,
    ResSpecialCharAndCharExceptPlusHyphen = 6,
    PasteSpecialCharExceptHyphenPlusNumber = 7,
    AddressRestriction = 8,
    PasteRestrictionAddress = 9,
    PostalCodeRestriction = 10,
    PasteRestrictionForPostalCode = 11,
}
